<template>
  <div id="app">
    <div class="card">
      <h1 class="header header--strong">
        Welcome to ndchristie.com
      </h1>
      <p class="paragraph">This domain has mutliple subdomains for different projects.  This site serves primarily as the portal for those projects.</p>
    </div>
    <div class="card">
      <redirect-timer url="http://portfolio.ndchristie.com">
    </div>
    <div class="card">
      <social-list v-bind:item-list="socialItemList"></social-list>
    </div>
    <footer class="card card--well">
      <p class="paragraph paragraph--fineprint">&copy; 2016 N.D.Christie</p>
    </footer>
  </div>
</template>

<script>
  import RedirectTimer from './components/RedirectTimer';
  import SocialList from './components/SocialList';
  require('./assets/stylesheets/application.scss');
  require('./assets/stylesheets/card.scss');
  export default {
    components: {
      RedirectTimer,
      SocialList,
    },
    data() {
      return {
        socialItemList: {
          email: {
            service: 'mail',
            url: 'mailto:nathan@ndchristie.com',
            displayString: 'nathan@ndchristie.com',
          },
          skype: {
            service: 'skype',
            url: 'skype:unicornrsunshine?add',
            displayString: 'unicornrsunshine',
          },
          linkedin: {
            service: 'linkedin',
            url: 'http://linkedin.com/in/ndchristie',
            displayString: 'ndchristie',
          },
          instagram: {
            service: 'instagram',
            url: 'http://instagram.com/ndchristie/',
            displayString: 'ndchristie',
          },
        },
      };
    },
    attached() {
      const sociconLink = document.createElement('link');
      sociconLink.rel = 'stylesheet';
      sociconLink.href = 'https://file.myfontastic.com/n6vo44Re5QaWo8oCKShBs7/icons.css';
      document.getElementsByTagName('head')[0].appendChild(sociconLink);
    },
  };
</script>

<style lang="scss">
</style>



/** WEBPACK FOOTER **
 ** App.vue?c5e6d674
 **/